module.exports = __webpack_public_path__ + "img/profil_perso@2x.1e19f73f.jpg";